export const SET_SIDEBAR_ITEM = "SET_SIDEBAR_ITEM";
export const SET_SIDEBAR_LOADING = "SET_SIDEBAR_LOADING";
export const SET_ARCHIVE_LOADING = "SET_ARCHIVE_LOADING";
export const SET_ARCHIVE_DATA = "SET_ARCHIVE_DATA";
export const setAppSideBarItem = (payload) => {
  return {
    type: SET_SIDEBAR_ITEM,
    payload,
  };
};

export const setSideBarLoading = () => {
  return {
    type: SET_SIDEBAR_LOADING,
  };
};

export const setArchiveItem = (payload) => {
  return {
    type: SET_ARCHIVE_DATA,
    payload,
  };
};

export const setArchiveTableLoading = () => {
  return {
    type: SET_ARCHIVE_LOADING,
  };
};
